import { RumEventType } from '../../rawRumEvent.types';
var allowedEventTypes = [RumEventType.ACTION, RumEventType.ERROR, RumEventType.LONG_TASK, RumEventType.RESOURCE, RumEventType.VITAL];
export function startEventCollection(lifeCycle) {
  return {
    addEvent: function addEvent(startTime, event, domainContext, duration) {
      if (!allowedEventTypes.includes(event.type)) {
        return;
      }

      lifeCycle.notify(12
      /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */
      , {
        startTime: startTime,
        rawRumEvent: event,
        domainContext: domainContext,
        duration: duration
      });
    }
  };
}